const CartDrawerCheckoutSummary = {
  props: {
    threshold: {
      type: Number,
      default: 0,
    },
    taxesShippingFreeText: {
      type: String,
      default: 'FREE',
    },
    taxesShippingText: {
      type: String,
      default: '',
    },
    shippingLabel: {
      type: String,
      default: 'Shipping',
    },
    savingsLabel: {
      type: String,
      default: 'Savings',
    },
  },
  computed: {
    totalSavings() {
      if (!this.$parent || !this.$parent.cart || !this.$parent.cart.items || this.$parent.cart.items.length === 0) {
        return 0;
      }

      // NOTE: There's a bug where the compare_at_price is undefined/null then uses the original_price
      //       to compute the savings, then it gets updated again once compare_at_price is available.
      const total_original_price = this.$parent.cart.items.reduce((sum, item) => {
        const item_price =
          item.compare_at_price && item.compare_at_price > 0 ? item.compare_at_price : item.original_price;
        return sum + item_price * item.quantity;
      }, 0);

      return total_original_price - this.$parent.cart.total_price;
    },
    remainingForFreeShipping() {
      if (!this.$parent || !this.$parent.cart) return 0;
      return Math.max(this.threshold - this.$parent.cart.items_subtotal_price, 0);
    },
    isEligibleForFreeShipping() {
      return this.remainingForFreeShipping === 0;
    },
  },
  methods: {
    formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: Shopify?.currency?.active || 'USD',
      }).format(cents / 100);
    },
  },
  template: `
    <div class="cart-drawer-checkout-summary">
      <div class="cart__savings" v-if="totalSavings > 0">
        <span>{{ savingsLabel }}</span>
        <span class="text-right">{{ formatMoney(totalSavings) }}</span>
      </div>
      <div class="cart__shipping rte text-link-animated">
        <span>{{ shippingLabel }}</span>
        <span class="text-right">
          <template v-if="isEligibleForFreeShipping">
            {{ taxesShippingFreeText }}
          </template>
          <template v-else>
            <span v-html="taxesShippingText"></span>
          </template>
        </span>
      </div>
    </div>
  `,
};

export default CartDrawerCheckoutSummary;

(function () {
  const MAX_RETRY_ATTEMPTS = 20;
  let retryCount = 0;

  function registerComponent() {
    if (retryCount >= MAX_RETRY_ATTEMPTS) {
      console.warn('Could not register CartDrawerCheckoutSummary component after maximum retry attempts');
      return;
    }

    retryCount++;

    const rightDrawerElement = document.querySelector('.right-drawer-vue');
    if (!rightDrawerElement) {
      setTimeout(registerComponent, 500);
      return;
    }

    if (rightDrawerElement.__vue__) {
      const vueInstance = rightDrawerElement.__vue__;
      if (vueInstance.$children && vueInstance.$children.length > 0) {
        const rightDrawer = vueInstance.$children[0];
        rightDrawer.$options.components = rightDrawer.$options.components || {};
        rightDrawer.$options.components['cart-drawer-checkout-summary'] = CartDrawerCheckoutSummary;

        document.documentElement.dispatchEvent(
          new CustomEvent('vue-components:registered', {
            detail: { components: ['cart-drawer-checkout-summary'] },
          })
        );
        return;
      }
    }

    if (window.theme && window.theme.rightDrawer) {
      const rightDrawer = window.theme.rightDrawer;
      rightDrawer.$options.components = rightDrawer.$options.components || {};
      rightDrawer.$options.components['cart-drawer-checkout-summary'] = CartDrawerCheckoutSummary;

      document.documentElement.dispatchEvent(
        new CustomEvent('vue-components:registered', {
          detail: { components: ['cart-drawer-checkout-summary'] },
        })
      );
      return;
    }

    setTimeout(registerComponent, 500);
  }

  document.documentElement.addEventListener('theme:ready', function () {
    registerComponent();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerComponent);
  } else {
    registerComponent();
  }
})();
